import { React, useState, useRef } from "react";
import { useDispatch } from "react-redux";

import { setContext } from "../../../features/context";
import config from "../../../config";
import { CommunityBasic, ImageEditor } from "../../widgets";
import validator from "../../../lib/validation";
import axiosCall from "../../../lib/axios";

const About = ({ language, signout, main_focus, props }) => {
  ///////////////// INITIALIZE /////////////////
  const { level, role, community, editMode, setEditMode } = props;

  const dispatch = useDispatch();
  const canvas_ref = useRef();
  const [showCrest, setShowCrest] = useState(false);
  const [file, setFile] = useState(null);

  ////////////// COMMUNITIES //////////////

  async function resetCommunities(object) {
    let obj = {
      role,
      id: object._id,
      uname: object.uname,
      license_type: object.license_type,
      title: object.title,
      crest: object.crest,
    };

    let communities = JSON.parse(localStorage.getItem("communities"));
    for (var i = 0; i < communities.length; i++) {
      if (communities[i].id === community._id) {
        communities[i] = obj;
        return communities;
      }
    }
  }

  ////////////// CREST //////////////
  const resetCrest = () => {
    setShowCrest(false);
    setFile(null);
  };

  function toggleImageEditor() {
    if (showCrest) setFile(null);
    setShowCrest(!showCrest);
  }

  const changeCrest = async (e, change = true) => {
    let click = true;
    if (e.key) click = false;
    if (!change) {
      resetCrest();
      if (!click) document.getElementById("toggle_image_editor").focus();
      return;
    }
    setFile(null);
    let canvas = canvas_ref.current;
    let data = { cid: community._id, current_crest: community.crest };
    if (canvas && file) {
      data.crest = canvas.toDataURL();
    } else {
      resetCrest();
      if (!click) document.getElementById("toggle_image_editor").focus();
      return;
    }
    // try and submit data
    let result = await axiosCall("community/crest", data);
    if (result.success) {
      // reset context
      const context = {
        ...community,
        crest: result.data,
      };
      dispatch(setContext(context));

      // reset communities
      const _communities = await resetCommunities(context);
      localStorage.setItem("communities", JSON.stringify(_communities));

      resetCrest();
      if (!click) document.getElementById("toggle_image_editor").focus();
    } else if (result.refresh) {
      // token has been refreshed, try again
      changeCrest(e);
    } else {
      // refresh token expired or unknown error
      signout();
    }
  };

  ///////////////// RENDER GUI /////////////////
  return (
    <div style={{ padding: `${level > 3 ? "1.5em 0 4em 0" : "1.5em 0"}` }}>
      <div className="page-section">
        <div style={{ display: "flex" }}>
          <div className="heading-icon">b</div>
          <div className="subheading">
            {language.labels.communities.about_community.replace(
              /{org}/g,
              community.title
            )}
          </div>
        </div>
      </div>

      {/* crest */}
      <div
        className="page-section"
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        {editMode && (
          <h2
            className="heading2 alert"
            style={{
              fontSize: "1.1em",
              fontWeight: "600",
              margin: "0 0.25em 1em 0",
            }}
          >
            {language.labels.app.edit_mode}
          </h2>
        )}

        {editMode && level > 2 && (
          <label className="text-label" style={{ marginBottom: "0.25em" }}>
            {language.labels.communities.logo}
          </label>
        )}
        <div
          className="thumb-block border"
          style={{
            backgroundImage: `url("${
              config.server.storage.bucket + community.crest
            }")`,
          }}
        >
          {editMode && level > 2 && (
            <button
              id="toggle_image_editor"
              className="button-edit left50"
              style={{
                padding: "0 .5em",
                position: "absolute",
                bottom: "-0.5em",
              }}
              title={language.labels.app.change}
              aria-label={language.labels.app.change}
              onClick={() => {
                toggleImageEditor();
              }}
            >
              <div aria-hidden="true" className="glyphs font-contrast">
                w
              </div>
              <div style={{ padding: "0 .2rem" }}></div>
              <div style={{ flexGrow: 0 }}>{language.labels.app.change}</div>
            </button>
          )}
        </div>
      </div>
      {showCrest && (
        <div
          className="page-section"
          style={{
            display: "flex",
            flexDirection: "column",
            maxWidth: "44rem",
          }}
        >
          <ImageEditor
            file={file}
            setFile={setFile}
            language={language}
            apply={changeCrest}
            ref={canvas_ref}
          />
        </div>
      )}

      {/* title, description and website */}
      {editMode && level > 2 ? (
        <CommunityBasic
          language={language}
          community={community}
          resetCommunities={resetCommunities}
          resetCrest={resetCrest}
          signout={signout}
          ref={main_focus}
        />
      ) : (
        <div className="page-section" style={{ maxWidth: "44rem" }}>
          <div style={{ marginTop: "1em" }}>{community.description}</div>
          {validator.URLchecker(community.website).host && (
            <div style={{ marginTop: "1em" }}>
              <a href={community.website} target={community.uname}>
                {validator.URLchecker(community.website).host}
              </a>
            </div>
          )}
        </div>
      )}

      {/* edit button */}
      {level > 2 && (
        <div className="page-section" style={{ paddingTop: "0" }}>
          {editMode ? (
            <div style={{ display: "flex", gap: "0.25em", margin: "3em 0" }}>
              <button
                className="button-secondary"
                onClick={() => setEditMode(false)}
              >
                {language.labels.app.edit_mode_leave}
              </button>
            </div>
          ) : (
            <button
              className="button-edit"
              style={{ padding: "0 1em", marginTop: "1.5em" }}
              title={language.labels.communities.edit}
              aria-label={language.labels.communities.edit}
              onClick={() => {
                setEditMode(true);
              }}
            >
              <div aria-hidden="true" className="glyphs font-contrast">
                w
              </div>
              <div style={{ padding: "0 .2rem" }}></div>
              <div style={{ flexGrow: 0 }}>
                {language.labels.communities.edit}
              </div>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default About;
